import React from 'react';

import Header from '../../global/Header';
import LegalText from "../../components/LegalText";
import StoryTile from '../../components/StoryTile';
import Loading from '../../components/Loading';
import PaginationLinks from '../../components/PaginationLinks';
import GridContainer from '../../global/GridContainer';
import useSearchData from '../../hooks/useSearchData';
import HeadingPrimary from "../../components/HeadingPrimary";

export default function Search() {
  const [ loading, error, data ] = useSearchData();
  const { stories, currentPage, itemCount, petType, breed, dietaryGoal } = data;

  if(loading) return (
  <main id="main" className="detail pt125 mih100vh" tabIndex="-1">
    <HeadingPrimary children="True Stories" className="tac fz64 fz32@sm mt24@sm"/>
    <Loading />
  </main>
  );

  if(error) return (
  <main id="main" className="detail pt125 mih100vh" tabIndex="-1">
    <HeadingPrimary children="True Stories" className="tac fz64 fz32@sm mt24@sm"/>
    <p>Error: {error.message}</p>
  </main>
  );

  if(itemCount === 0) return (
    <main id="main" className="detail mih100vh" tabIndex="-1">
      <GridContainer className="pt125 tac">
        <HeadingPrimary children="True Stories" className="tac fz64 fz32@sm mt24@sm"/>
        <LegalText className="mb48 mb32@sm" />
        <p className="fz25">
          Looks like there are no True Stories that fill all of your selections.<br/><br/>
          Please adjust your choices.
        </p>
      </GridContainer>
    </main>
    )

  return (
  <main id="main" className="search bgc-white" tabIndex="-1">
    <GridContainer className="pt125 pt0@sm">
      <HeadingPrimary children="True Stories" className="tac fz64 fz32@sm mt24@sm"/>
      <LegalText className="mb48 mb32@sm" />
      <section className="search__results dg aic fxww jcc g24 gcolm3 gcolm2@md gcolm1@smx">
      {
        stories.map((story, i) => (
          <StoryTile
            key={i}
            petData={story}
          />
        ))
      }
      </section>
      <div className="tac pt48 pb80 pt32@sm">
        <PaginationLinks
          itemCount={itemCount}
          itemsPerPage={36}
          currentPage={currentPage}
          generatePath={page => `/apps/truestories/story/search?petType=${petType}&breed=${breed}&dietaryGoal=${dietaryGoal}&page=${page-1}`}
        />
      </div>
    </GridContainer>
  </main>
  );
}
